import React, { Component } from 'react';

import './KPI.css';

import { services10 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { axiosErrorHandler, nullUndefined, toast_request_error } from '@acri-tools/react-tools/utils';
import { API_URL, get_page_title } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import Select from '@acri-tools/react-tools/components/Select/Select';
import { Helmet } from 'react-helmet';

interface Props{
}
interface State{
    files?:Array<any>
    kpi?:any
    loading:boolean
}

const MONTHS:any = {
    'january': 0,
    'february': 1,
    'march': 2,
    'april': 3,
    'may': 4,
    'june': 5,
    'july': 6,
    'august': 7,
    'september': 8,
    'october': 9,
    'november': 10,
    'december': 11,
}
const MONTHS_FR:any = {
    'janvier': 0,
    'fevrier': 1,
    'mars': 2,
    'avril': 3,
    'mai': 4,
    'juin': 5,
    'juillet': 6,
    'aout': 7,
    'septembre': 8,
    'octobre': 9,
    'novembre': 10,
    'decembre': 11,
}
    



const get_month = (month:string) =>{
    if(month in MONTHS) return MONTHS[month];
    if(month in MONTHS_FR) return MONTHS[month];
    else return 0;
    
}

class KPI extends Component<Props,State>{

    constructor(props:Props){
        super(props);
        this.state = {
            loading: false
        }
    }

    componentDidMount(){
        this.fetch();
    }


    fetch = async() =>{
        this.setState({ loading: true });
        try{
            let res = await request(`${API_URL}/api/user-manager/v1/files/KPI`,{
                method: 'get'
            })

            let files = [];
            
            for(let file of res.data.value){
                try{
                    let [ , month, year ] = file.name.split('.')[0].split('_'); 
                    let date = new Date(parseInt(year), get_month(month.toLowerCase()));

                    if(Number.isNaN(date.getTime())) {
                        console.error('invalid date', file.name);
                        continue;
                    }
                    
                    files.push({
                        date_string: `${year} ${month}`,
                        date,
                        file: `${API_URL}/api/user-manager/v1/files/KPI/${file.name}`
                    })
                }
                catch(e:any){
                    console.error('format kpi files error', e);
                }
            };

            files.sort((a:any, b:any)=> {
                // return a.date?.getTime() - b.date?.getTime();
                return b.date?.getTime() - a.date?.getTime();
            })


            console.debug('kpi', files);

            this.setState({ files, kpi: files.length > 0 ? files[0] : undefined });
            // this.setState({ files, kpi: files.length > 0 ? 0 : undefined });
        }
        catch(e:any){
            axiosErrorHandler(e, { functionName: `fetch` });
            toast_request_error(e);
        }
        finally{
            this.setState({ loading:false })
        } 
    }

    render(){
        return (
        <Page 
            id="KPI"
            banner={{
                title: "KPI",
                bannerImage: services10,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - KPI') }</title>
                <meta 
                    name="description" 
                    content="DAMPS KPI details"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <Select
                        search
                        no_value_search
                        className="kpi-select"
                        onChange={(kpi:any)=>{
                            this.setState({ kpi })
                        }}
                        value={this.state.kpi}
                        
                        options={(this.state.files || []).map((file:any, key:number)=>{
                            return { label: file.date_string, value: file }
                        })}
                    />
                    {
                        nullUndefined(this.state.kpi) ?
                            <div className="no-data">
                                No KPIs currently.
                            </div>
                        :
                            <div className="kpi">
                                <img alt="kpi values" src={this.state.kpi?.file}/>
                                {/* <img src={this.state.files?.[this.state.kpi]?.file}/> */}
                            </div>
                    }
                </div>
            </div>
        </Page>
        );
    }

};


export default KPI;
